import { Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InsightsServiceApi } from '../insights.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as pbi from 'powerbi-client';
import { UtilsService } from '../../../services/utils.service';
import { DownloadFileService } from '../../../services/downloadFile.service';

@Component({
  selector: 'app-sku-generator',
  templateUrl: './sku-generator.component.html',
  styleUrls: ['./sku-generator.component.scss'],
  standalone: false
})
export class SkuGeneratorComponent implements OnInit {



  @ViewChild('powerBIContainer', { static: true }) powerBIContainer!: ElementRef;
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
  showBoolean: boolean;
  regions: any = [];
  productLines: any = [];
  requstList: any = [];
  message: boolean = false;
  visualForm: FormGroup;
  selectedRegion: any;
  selectedProductLine: string[] = [];
  selectedRequest: any;
  embadedURL: any;
  embedToken: any;
  reportId: any;
  fileName: any;
  isReportVisible: boolean = true;
  uploadedFile: any;
  isFileUploaded: boolean = false;
  isPLDisabled: boolean = true;
  isPRDisabled: boolean = true;
  isFileUploadDisabled: boolean = true;
  isSubmitDisabled: boolean = true;
  getSharingErorr: any
  isShowErrorMessageWithToast: boolean;
  displayStyle: string;
  isSubmitSuccessful: boolean = false;

  // Tab management
  activeTab: string = 'insights';

  isConfirmationPopupVisibale: boolean;
  popupMessage: any;
  isSuccessToast: boolean = true;
  errorFlag: boolean = false;
  fileError: any;
  getFileSize: any;
  uploadProgress = 0;
  uploadInProgress = false;
  getSharingError: any;
  pairingId: any;


  constructor(
    private readonly insightsServiceApi: InsightsServiceApi,
    private readonly spinnerService: NgxSpinnerService,
    private fb: FormBuilder,
    private readonly utilService: UtilsService,
    private readonly downloadFileService: DownloadFileService,
    private readonly router: Router
  ) {
  }

  ngOnInit() {
    this.utilService.SharingData.subscribe((res: any) => {
      this.getSharingErorr = res;
    });
    this.getRegionDetails();
    this.requestSubmitted = false;
    this.buildForm();

    this.utilService.SharingData.subscribe((res: any) => {
      this.getSharingError = res;
    });
  }

  isPLOpen = false
  isRegionOpen = false
  isPROpen = false

  requestSubmitted = false

  openPL() {
    this.isPLOpen = !this.isPLOpen
    this.isRegionOpen = false
    this.isPROpen = false
  }

  openReg() {
    this.isPLOpen = false
    this.isRegionOpen = !this.isRegionOpen
    this.isPROpen = false
  }


  openPR() {
    this.isPLOpen = false
    this.isRegionOpen = false
    this.isPROpen = !this.isPROpen
  }

  // Tab management methods
  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  buildForm() {
    this.visualForm = this.fb.group({
      userId: [''],
      productLine: [[]],
      regionCode: [[]],
      filename: [''],
      requestId: [''],
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadedFile = input.files[0];
      this.getFileSize = input.files[0].size;
      this.uploadReport();
    }
  }

  private handlePopupMessage(isShowPopupMessage: boolean, message: string, isSuccess: boolean) {
    if (isShowPopupMessage) {
      this.isReportVisible = false;
      this.popupMessage = message
      this.isSuccessToast = isSuccess;
      this.displayStyle = 'none';
      this.isConfirmationPopupVisibale = true;
      this.isShowErrorMessageWithToast = true;
      this.utilService.isTosterVisible(true, message);
      setTimeout(() => {
        this.isShowErrorMessageWithToast = false;
        this.utilService.isTosterVisible(false, '');
      }, 5000);
    } else {
      this.isShowErrorMessageWithToast = false;
    }
  }

  actionOnConfirmation() {

    this.selectedProductLineIds.set([]);
    this.selectedRegions.set([]);
    this.selectedPR.set({ requestId: '', label: '' });
    this.fileInputRef.nativeElement.value = '';
    this.selectedRegion = '';
    this.selectedProductLine = [];
    this.selectedRequest = '';
    this.isFileUploaded = false;
    this.displayStyle = 'none';

  }

  // regions call
  getRegionDetails() {
    this.insightsServiceApi
      .getRegions()
      .subscribe(
        (res) => {
          const regionLsts = res;
          this.regions = regionLsts.result;
          this.regions = this.regions.filter(function (el: any) {
            return el !== 'NULL';
          });
          this.showBoolean = false;
        },
        (err) => {
          this.spinnerService.hide();
          this.showBoolean = true;
        }
      );
  }

  getProductLineDetails(regionCodeOnEdit: any) {
    this.insightsServiceApi
      .getProductLines(
        regionCodeOnEdit
      )
      .subscribe(
        (res) => {
          const productLineLists = res;
          this.productLines = productLineLists.result;
          this.productLines = this.productLines.filter(function (el: any) {
            return el !== 'NULL';
          });

          //this.isProductLineDisabledOnRegion = true;
          return this.productLines;
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  getPairingRquest() {
    const productLineCodes = this.selectedProductLineIds()
      .map(desc => this.getPLCodeByDescription(desc))
      .filter((c): c is string => !!c);
    this.selectedProductLine = productLineCodes;
    this.insightsServiceApi
      .getPairingRequest(this.selectedRegion, productLineCodes)
      .subscribe(
        (res) => {
          const requestLists = res;
          this.requstList = requestLists.result;
          this.requstList = this.requstList.filter(function (el: any) {
            return el !== 'NULL';
          });


          return this.requstList;
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }


  uploadReport() {
    let formData = new FormData();

    formData.append('file', this.uploadedFile);
    formData.append('userId', sessionStorage.getItem('userId'));
    formData.append('productLineCode', this.selectedProductLine[0] || '');
    //formData.append('regionCode', this.selectedRegion);
    formData.append('module', 'sku-generator');

    this.insightsServiceApi.uploadReport(formData).subscribe(
      (response: any) => {


        const getFileResponse: any = response;
        if (getFileResponse.body.message === 'OK') {
          this.isFileUploaded = true;
          this.errorFlag = false;
          this.fileError = '';

          this.isSubmitDisabled = false;
          this.isSubmitSuccessful = false;
          this.isFileUploadDisabled = true;
          this.selectedPR.set(null);
          this.selectedRequest = '';
          this.fileName = getFileResponse.body.result;
        } else {
          this.errorFlag = true;
          this.fileError = getFileResponse.body.message;
        }
        setTimeout(() => {
          this.spinnerService.hide();
        }, 1000);

      },
      (error: any) => {
        const uploadError = this.getSharingError;
        this.utilService.SharingData.next(null);
        this.errorFlag = true;
        this.fileError = uploadError;
      }
    );
  }


  reqSubmit() {
    this.requestSubmitted = true;
    let fileName: string = this.isFileUploaded ? this.fileName : '';
    let requestId: string = this.isFileUploaded ? '' : this.selectedRequest;
    
    this.visualForm.patchValue({
      userId: sessionStorage.getItem('userId'),
      productLine: this.selectedProductLine,
      regionCode: this.selectedRegion,
      filename: fileName,
      requestId: requestId,
    });


    this.isSubmitDisabled = true;
    this.spinnerService.show();
    this.insightsServiceApi
      .onSubmitSKU(this.visualForm.value)
      .subscribe(
        (res: any) => {
          if (res.code === 200) {
            this.isReportVisible = false;
            this.isSubmitSuccessful = true;
            this.pairingId = res.result.requestId;
            if (res.result.requestId) {
              this.handlePopupMessage(true, `Request ID ${this.pairingId} has been added successfully.`, true);
              this.utilService.goToTop();

            } else {
              this.handlePopupMessage(true, 'No Records Found', false);
            }

            // Clear all form data and selections
            this.visualForm.reset();
            this.selectedProductLineIds.set([]);
            this.selectedRegions.set([]);
            this.selectedPR.set(null);
            this.selectedRegion = '';
            this.selectedProductLine = [];
            this.selectedRequest = '';
            this.isFileUploaded = false;
            this.fileName = '';
            this.errorFlag = false;
            this.fileError = '';
            this.getFileSize = null;
            if (this.fileInputRef) {
              this.fileInputRef.nativeElement.value = '';
            }

          } else {
            this.handlePopupMessage(true, 'No Records Found', false);
          }
          setTimeout(() => {
            this.spinnerService.hide();
          }, 1000);
        },
        (err: any) => {
          //console.log(err);
          this.handlePopupMessage(true, 'Something went wrong. Please try again later.', false);
          setTimeout(() => {
            this.spinnerService.hide();
          }, 1000);
        }
      );


  }


  selectedProductLineIds = signal<string[]>([]);
  selectedRegions = signal<string[]>([]);
  selectedPR = signal<{ requestId: string; label: string } | null>(null);

  togglePLSelection(name: string) {
    const MULTI_SELECT_CODES = ['CT', 'MIN'];
    const code = this.getPLCodeByDescription(name);

    if (code && MULTI_SELECT_CODES.includes(code)) {
      // Multi-select: toggle within CT/MIN selections, clear any non-CT/MIN previously selected
      const current = this.selectedProductLineIds().filter(desc => {
        const c = this.getPLCodeByDescription(desc);
        return c && MULTI_SELECT_CODES.includes(c);
      });
      if (current.includes(name)) {
        const updated = current.filter(d => d !== name);
        this.selectedProductLineIds.set(updated);
        if (updated.length === 0) {
          this.selectedProductLine = [];
          this.isPRDisabled = true;
          this.isFileUploadDisabled = true;
          this.isSubmitDisabled = true;
          return;
        }
      } else {
        this.selectedProductLineIds.set([...current, name]);
      }
      // Keep dropdown open for multi-select
    } else {
      this.clearData('productLine');
      this.selectedProductLineIds.set([name]);
      this.isPLOpen = false;
      this.selectedProductLine = [this.getPLCodeByDescription(name)].filter((c): c is string => !!c);
    }

    this.getPairingRquest();
    this.isPRDisabled = false;
    this.isFileUploadDisabled = true;
    this.isSubmitDisabled = true;
    this.isSubmitSuccessful = false;
  }

  toggleRegionSelection(name: string) {
    this.clearData('region');
    this.selectedRegions.set([name]);
    this.isRegionOpen = false;
    this.selectedRegion = this.selectedRegions()[0];
    this.selectedRegion = this.getRegionCodeByName(this.selectedRegion);
    this.getProductLineDetails(this.selectedRegion);
    this.isPLDisabled = false;
    this.isPRDisabled = true;
    this.isFileUploadDisabled = true;
    this.isSubmitDisabled = true;
  }




  togglePRSelection(requestId: string) {
    const selected = this.requstList.find((req: { requestId: string; label: string }) => req.requestId === requestId) || null;
    this.selectedPR.set(selected);
    this.isPROpen = false;
    this.selectedRequest = requestId;
    this.isSubmitSuccessful = false;
    this.isFileUploadDisabled = true;
    this.isSubmitDisabled = false;
  }

  getRegionCodeByName(name: string): string | undefined {
    const region = this.regions.find((r: { regionName: string; }) => r.regionName === name);
    return region?.regionCode;
  }

  getPLCodeByDescription(name: string): string | undefined {
    const pl = this.productLines.find((r: { description: string; }) => r.description === name);
    return pl?.code;
  }


  clearData(type: string) {
    if (type === 'region') {
      this.selectedProductLineIds.set([]);
      this.selectedProductLine = [];
    }
    this.requstList = [];
    this.isFileUploaded = false;
    this.errorFlag = false;
    this.fileError = '';
    this.getFileSize = null;
    this.fileName = '';
    this.selectedPR.set(null);
    if (this.fileInputRef?.nativeElement) {
      this.fileInputRef.nativeElement.value = '';
    }
    this.selectedRequest = '';
    this.displayStyle = 'none';
  }

  downloadSKUFile() {
    this.downloadFileService.downloadPriceFXFile();
  }

  public fileOver(event: any) {
    //console.log(event);
  }

  public fileLeave(event: any) {
    //console.log(event);
  }

   goToReports() {
    this.utilService.goToReports();
  }
  goToHome() {
    this.router.navigate(['/home']);
  }

}
